import {DashboardCard} from '../dashboard-card/DashboardCard'
import {useTranslation} from '@/translations/i18n'
import {Text} from '@/components/ui/text/Text'
import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {Grid} from '@/components/ui/grid-atoms/GridAtoms'
import {Skeleton} from '@/components/ui/skeleton/Skeleton'

export const DashboardDoctorsPsychologistsCardSkeleton = () => {
    const {t} = useTranslation()

    return (
        <DashboardCard title={t('dashboard:doctors_psychologists')}>
            <Grid columns={2} gap={2}>
                <Flexbox direction="column" gap={4}>
                    <Skeleton width={60} height={28} />

                    <Flexbox direction="column" gap={2}>
                        <Flexbox align="center" gap={2}>
                            <Skeleton width={16} height={16} />
                            <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                {t('dashboard:doctors_psychologists_flat_rate')}
                            </Text>
                        </Flexbox>
                        <Flexbox align="center" gap={2}>
                            <Skeleton width={16} height={16} />
                            <Text palette="neutral" shade="600" size="textSm" weight={400}>
                                {t('dashboard:doctors_psychologists_consultant')}
                            </Text>
                        </Flexbox>
                    </Flexbox>
                </Flexbox>
                <Flexbox align="center" justify="center">
                    <Skeleton width={120} height={120} style={{borderRadius: '50%'}} />
                </Flexbox>
            </Grid>
        </DashboardCard>
    )
}
